import { ToastVariants } from '@features/ui-atoms/components/Toast';
import { showToast } from '@features/ui-atoms/services/showToast';
import FetchError from '@services/api/utils/FetchError';
import { Mutation, Query, QueryKey } from '@tanstack/react-query';
import { TFunction } from 'i18next';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { destroyCookie } from 'nookies';

const responseMessages: Record<number, string> = {
  200: 'Success',
  201: 'Created',
};
const errorMessages: Record<number, string> = {
  400: 'Bad Request',
  401: 'Unauthorized action',
  403: 'Access denied',
};

export const handleGenericMutationErrors = (
  error: FetchError,
  variables: unknown,
  context: unknown,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
  router: AppRouterInstance,
  t: TFunction<'translation', undefined>,
): void => {
  let errorMessage = 'An error occured';
  let status: number | undefined;

  if (error.response.status) {
    status = error.response.status;
  }

  if (mutation.meta?.errorMessage) {
    errorMessage = mutation.meta?.errorMessage as string;
  } else if (status && status in errorMessages) {
    errorMessage = t(errorMessages[status]);
  }

  showToast({
    variant: ToastVariants.ERROR,
    title: t('api.error'),
    message: t(errorMessage),
  });
  handleHTTPStatus(error.response.status, router);
};

export const handleGenericQueryErrors = (
  error: FetchError,
  query: Query<unknown, unknown, unknown, QueryKey>,
  router: AppRouterInstance,
  t: TFunction<'translation', undefined>,
): void => {
  let errorMessage = 'An error occured';
  let status: number | undefined;

  if (error.response && error.response.status !== undefined) {
    status = error.response.status;
  }

  if (query.meta?.errorMessage) {
    errorMessage = query.meta?.errorMessage as string;
  } else if (status !== undefined && status in errorMessages) {
    errorMessage = errorMessages[status];
  }

  showToast({
    variant: ToastVariants.ERROR,
    title: t('api.error'),
    message: t(errorMessage),
  });

  if (error.response && error.response.status) {
    handleHTTPStatus(error.response.status, router);
  }
};

export const handleGenericMutationSuccess = (
  data: unknown,
  variables: unknown,
  context: unknown,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
  router: AppRouterInstance,
  t: TFunction<'translation', undefined>,
): void => {
  showToast({
    variant: ToastVariants.SUCCESS,
    title: t('api.success'),
    message: t(responseMessages[200]),
  });
};

export const handleHTTPStatus = (code: number, router: AppRouterInstance): void => {
  if (code === 401 || code === 403) {
    destroyCookie(null, 'api_backend_token', { path: '/' });
    router.replace('/login');
  }
};
